<!--
 * 严肃声明：
 * 开源版本请务必保留此注释头信息，若删除我方将保留所有法律责任追究！
 * 本系统已申请软件著作权，受国家版权局知识产权以及国家计算机软件著作权保护！
 * 可正常分享和学习源码，不得用于违法犯罪活动，违者必究！
 * Copyright (c) 2020 陈尼克 all rights reserved.
 * 版权所有，侵权必究！
 *
-->

<template>
  <div class="categray">
    <div>
      <header class="category-header wrap van-hairline--bottom">
        <i class="nbicon nbfanhui" @click="goHome"></i>
        <div class="header-search">
          <i class="nbicon nbSearch"></i>
          <router-link
            tag="span"
            class="search-title"
            to="./product-list?from=category"
            >请输入查找内容</router-link
          >
        </div>
        <i class="iconfont icon-More"></i>
      </header>
      <nav-bar></nav-bar>
      <div class="search-wrap" ref="searchWrap">
        <list-scroll :scroll-data="categoryData" class="nav-side-wrapper">
          <ul class="nav-side">
            <li
              v-for="item in categoryData"
              :key="item.categoryId"
              :class="{ active: currentIndex == item.categoryId }"
              @click="selectMenu(item.categoryId)"
            >
              <span>{{ item.categoryName }} </span>
            </li>
          </ul>
        </list-scroll>
        <div class="search-content">
          <list-scroll :scroll-data="categoryData">
            <div class="swiper-container">
              <div class="swiper-wrapper">
                <template v-for="(category, index) in categoryData">
                  <div
                    class="swiper-slide"
                    v-if="currentIndex == category.categoryId"
                    :key="index"
                  >
                    <div @click="goDiscount" class="catogory-title">
                      <img src="../assets/category.png" alt="" />
                    </div>
                    <div
                      class="category-list"
                      :key="a"
                      v-for="(categorytwo, a) in categoryData[index]
                        .secondLevelCategoryVOS"
                    >
                      <div class="product-title">
                        <span>{{ categorytwo.categoryName }}</span>
                      </div>
                      <div class="product-list">
                        <ul>
                          <li
                            :key="b"
                            v-for="(
                              categorythree, b
                            ) in categorytwo.thirdLevelCategoryVOS"
                            @click="goToDetail(categorythree.categoryId)"
                          >
                            <img :src="categorythree.image" alt="" />
                            <p>{{ categorythree.categoryName }}</p>
                          </li>
                          <div class="clear"></div>
                        </ul>
                      </div>
                    </div>
                  </div>
                </template>
              </div>
            </div>
          </list-scroll>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { reactive, onMounted, ref, toRefs } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import navBar from '@/components/NavBar'
import listScroll from '@/components/ListScroll'
import { getCategoryall, search } from '@/service/good'
import { getLocal, setLocal } from '@/common/js/utils'

import { Toast } from 'vant'
export default {
  components: {
    navBar,
    listScroll
  },
  setup() {
    const router = useRouter()
    const route = useRoute()
    const { categoryId } = route.query
    // composition API 获取 refs 的形式
    const searchWrap = ref(null)
    const state = reactive({
      categoryData: [],
      currentIndex: null,
      orderBy: 'price',
      page: 1,
      productList: []
    })

    onMounted(async () => {
      let $screenHeight = document.documentElement.clientHeight
      searchWrap.value.style.height = $screenHeight - 100 + 'px'
      const { data } = await getCategoryall()
      if (getLocal('categoryId')) {
        state.currentIndex = getLocal('categoryId')
      } else if (categoryId) {
        state.currentIndex = categoryId
      } else {
        state.currentIndex = data[0].categoryId
      }
      Toast.clear()
      state.categoryData = data
    })

    const goHome = () => {
      router.push({ path: 'home' })
    }

    const selectMenu = (index) => {
      state.currentIndex = index
      setLocal('categoryId', index)
      search({
        pageNumber: state.page,
        goodsCategoryId: index,
        orderBy: state.orderBy
      }).then((res) => {
        state.productList = res.data.list
      })
    }
    const goDiscount = () => {
      router.push({ path: '/Discount' })
    }
    const goToDetail = (item) => {
      router.push({ path: `/product-list`, query: { categoryId: item } })
    }
    // const selectProduct = (item) => {
    //   router.push({
    //     path: '/product-list',
    //     query: { categoryId: item.categoryId }
    //   })
    // }
    return {
      goDiscount,
      goToDetail,
      ...toRefs(state),
      goHome,
      selectMenu,
      searchWrap
    }
  }
}
</script>
<style lang="less" scoped>
@import '../common/style/mixin';
.clear {
  clear: both;
}
.categray {
  .category-header {
    background: #fff;
    position: fixed;
    left: 0;
    top: 0;
    .fj();
    .wh(100%, 50px);
    line-height: 50px;
    padding: 0 15px;
    box-sizing: border-box;
    font-size: 15px;
    color: #656771;
    z-index: 10000;
    &.active {
      background: @primary;
    }
    .icon-left {
      font-size: 25px;
      font-weight: bold;
    }
    .header-search {
      display: flex;
      width: 80%;
      height: 20px;
      line-height: 20px;
      margin: 10px 0;
      padding: 5px 0;
      color: #232326;
      background: #f7f7f7;
      border-radius: 20px;
      .nbSearch {
        padding: 0 10px 0 20px;
        font-size: 17px;
      }
      .search-title {
        font-size: 12px;
        color: #666;
        line-height: 21px;
      }
    }
    .icon-More {
      font-size: 20px;
    }
  }
}
.search-wrap {
  .fj();
  width: 100%;
  margin-top: 50px;
  background: #f8f8f8;
  .nav-side-wrapper {
    width: 28%;
    height: 100%;
    overflow: auto;
    .nav-side {
      width: 100%;
      .boxSizing();
      background: #f8f8f8;
      li {
        width: 100%;
        text-align: center;
        font-size: 14px;
        padding: 10px 0;

        &.active {
          color: @primary;
          background: #fff;
        }
      }
    }
  }
  .search-content {
    width: 72%;
    height: 100%;
    padding: 0 10px;
    background: #fff;
    overflow-y: scroll;
    touch-action: pan-y;
    * {
      touch-action: pan-y;
    }
    .boxSizing();
    .swiper-container {
      width: 100%;
      .swiper-slide {
        width: 100%;
        .category-main-img {
          width: 100%;
        }
        .catogory-title {
          width: 100%;
          font-size: 17px;
          font-weight: 500;
          padding: 20px 0;
          span {
          }
          img {
            width: 100%;
          }
        }
        .category-list {
          width: 100%;
          .product-title {
            span {
              font-size: 14px;
              font-weight: bold;
              color: #4e4c4c;
              border-bottom: 2px solid #4e4c4c;
              margin-bottom: 20px;
              display: inline-block;
            }
          }
          ul li {
            width: 33%;
            float: left;
            text-align: center;
            img {
              width: 50px;
              height: 50px;
              overflow: hidden;
            }
            p {
              overflow: hidden; //超出隐藏
              text-overflow: ellipsis; //显示省略号
              white-space: nowrap; //强制不换行
              height: 20px;
              line-height: 20px;
            }
          }
        }
      }
    }
  }
}
.fade-out-enter-active,
.fade-out-leave-active {
  // transition: opacity 0.5s;
}

.fade-out-enter,
.fade-out-leave-to {
  // opacity: 0;
}
</style>